import { render } from "./MetricDashboardYearGraphic.vue?vue&type=template&id=596f36b4&ts=true"
import script from "./MetricDashboardYearGraphic.vue?vue&type=script&lang=ts"
export * from "./MetricDashboardYearGraphic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__